import React, { useEffect, useState, useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { getEncashedLeavesReport } from '../../Services/ReportService'; // Update with your actual API functions

const LeavesTable = (props) => {  
    const gridRef = useRef(); 
    const [rowData, setRowData] = useState(); 
    const [columnDefs, setColumnDefs] = useState();
    const defaultColDef = useMemo(() => ({
      sortable: true,
    }));

  const getRowData = () => {
    const data = props.reportData?.data?.content;
    let rowData = [];
    for (let i = 0; i < data?.length; i++) {
      let currentRow = {
        employeeCode: data[i].employeeCode,
        fullName: data[i].fullName,
        noOfEncashableLeaves: data[i].noOfEncashableLeaves,
        year: data[i].year,
        leaveName: data[i].leaveName,
        isEncashmentDone: data[i].isEncashmentDone,
        noOfCarryForwardLeaves : data[i].noOfCarryForwardLeaves
      };
      rowData.push(currentRow);
    }
    setRowData(rowData);
  };

  const getColumnDefs = () => {
    let columnDefs = [];
    columnDefs.push(
      { headerName: 'Employee Code', field: 'employeeCode' },
      { headerName: 'Full Name', field: 'fullName' },
      { headerName: 'Encashment Leaves', field: 'noOfEncashableLeaves' },
      { headerName: 'Carry Forward leaves', field: 'noOfCarryForwardLeaves'},
      { headerName: 'Leave Type', field: 'leaveName'},
      { headerName: 'Year', field: 'year' },
      { headerName: 'Encashment Status', field: 'isEncashmentDone',valueFormatter: params => {
        switch(params.value) {
          case true:
            return 'Done';
          case false:
            return 'Pending';
          default:
            return 'N/A';
        }
      }},
    );
    setColumnDefs(columnDefs);
  };

  useEffect(() => {
    getRowData();
    getColumnDefs();
  }, [props.reportData]);
  return (
    <>
      <div className="ag-theme-alpine" style={{ height: '400px', width: '100%'}}>
          <AgGridReact
            ref={gridRef}
            defaultColDef={defaultColDef}
            rowData={rowData}
            columnDefs={columnDefs}
            animateRows={true}
            rowSelection="multiple"
            suppressExcelExport={true}
            suppressCellFocus={true}
            autoSizeColumns={true}
          />
          
      </div>
    </>
  );
};

export default LeavesTable;
